<template>
	<div class="news-banner-mobile">
      <swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="0"
    :pagination="{ clickable: true }"
    :autoplay="{ delay: 3000, disableOnInteraction: false }"
    :loop="true"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    class="my-banner-swiper"
  >
    <swiper-slide v-for="(item, index) in bannerList" :key="index">
      <div class="banner-item" :style="'background:url('+commenUrl+item+') no-repeat center;background-size: 100% 100%;'">
        <h2 :style="'color:'+themeColor">{{bannerObject.mc}}</h2>
        <p :style="'color:'+themeColor">{{bannerObject.js}}</p>
      </div>
      
    </swiper-slide>

    </swiper>
    </div>
</template>

<script setup>
import {reactive,ref, getCurrentInstance, onMounted, watch} from "vue";
import { useRouter,useRoute } from 'vue-router';
import { Search,Menu,Expand } from '@element-plus/icons-vue'
import { Swiper, SwiperSlide } from 'swiper/vue';// 导入 Swiper 样式
// 只包含核心样式：
import 'swiper/css';
// 如果使用了分页器(Pagination)、导航(Navigation)等模块，需要额外导入样式
import 'swiper/css/pagination';
import 'swiper/css/navigation'; 
import 'swiper/css/autoplay'; 

// 导入需要的模块（例如：分页、自动播放）
import { Pagination, Autoplay } from 'swiper/modules';
const props = defineProps({
  themeColor: {
    type: String,
    default: '#191919'
  }
})
const route=useRoute();
const router=useRouter();
const {proxy}= getCurrentInstance();
const modules = [Pagination, Autoplay];

const onSwiper = (swiper) => {
  console.log('Swiper 实例创建:', swiper);
};

const onSlideChange = () => {
  console.log('Slide 发生改变');
};
console.log('route',route)
let path=route.fullPath.split("/")[route.fullPath.split("/").length-1];
if(path.indexOf("&")&&route.path=='/newsList'){
  path=path.split("&")[0]
}
console.log('path',path)
const bannerObject=ref({});
const bannerList=ref([]);
function getArticleList(){
  proxy.$request({
    url:"N_QPSTZX_BANNERTGL_BANNERTGL",
    data:{
      "ly":path
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      let result=res.data.result;
      if(result&&result.length>0){
        bannerObject.value=result[0];
        bannerList.value=bannerObject.value.tp.split(",");
      }
    }
  }).catch((err)=>{
    console.log(err)
  })
}
getArticleList();

watch(()=>route.fullPath,(newValue,oldValue)=>{
  if(newValue){
    path=newValue.split("/")[1];
    getArticleList();
  }
});
</script>


<style lang="less">
.news-banner-mobile{
  width: 100%;
  height: 50vw;
  .swiper-slide{
    height: 50vw;
    .banner-item{
      width: 100%;
      height: 100%;
      text-align: center;
      h2{
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: 16px;
        color: #191919;
        line-height: 22px;
        margin-bottom: 10px;
        padding-top: 70px;
      }
      p{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #616161;
        line-height: 17px;
      }
    }
  }
}
</style>